import { Component as t } from "react";
function e(t) {
  return (e = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function r(t, e) {
  return (r = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
var o,
  n,
  c = function (t) {
    !function (t, e) {
      if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
      t.prototype = Object.create(e && e.prototype, {
        constructor: {
          value: t,
          writable: !0,
          configurable: !0
        }
      }), e && r(t, e);
    }(c, t);
    var o,
      n = (o = function () {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
          return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
          return !1;
        }
      }(), function () {
        var t,
          r,
          n = e(c);
        if (o) {
          var u = e(this).constructor;
          r = Reflect.construct(n, arguments, u);
        } else r = n.apply(this, arguments);
        return (t = r) && ("object" == (t && "undefined" != typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t) || "function" == typeof t) ? t : function (t) {
          if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
          return t;
        }(this);
      });
    function c() {
      return !function (t, e) {
        if (!(t instanceof e)) throw TypeError("Cannot call a class as a function");
      }(this, c), n.apply(this, arguments);
    }
    return c;
  }(t);
n = {
  cellEditValidatorEvent: "click"
}, (o = "defaultProps") in c ? Object.defineProperty(c, o, {
  value: n,
  enumerable: !0,
  configurable: !0,
  writable: !0
}) : c[o] = n;
export { c as Column };